import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { businessStartupSupportFaqItems } from '../../data/faqs/business-startup-support'
import { PageMeta } from '../../types'

const description = "新しいビジネスをゼロから立ち上げるには、構想力と検証力、そして実行力が求められます。本サービスでは、顧客起点の課題探索から仮説検証、MVP開発、PMFまでを一貫して支援し、不確実性の高い立ち上げフェーズを成功に導きます。"

export const businessStartupSupportPageMeta: PageMeta = {
  title: "新規事業プロジェクト実行支援 | サービス | i3DESIGN アイスリーデザイン",
  description,
  keyword: "新規事業 フィットジャーニー スタートアップ DX 実行力 仮説検証 MVP開発",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/business-startup-support/`,
}

const businessStartupSupportServiceSchema = buildServiceSchema({
  slug: "business-startup-support",
  name: "新規事業プロジェクト実行支援",
  description: businessStartupSupportPageMeta.description,
  serviceType: "新規事業プロジェクト実行支援",
  category: "プロダクト成長支援",
  offerCatalogName: "新規事業プロジェクト実行支援サービス",
  breadcrumbName: "新規事業プロジェクト実行支援",
  offers: [
    {
      name: "新規事業プロジェクト実行支援",
      description: "ユーザーリサーチからMVP開発、GTM戦略、アジャイル開発までを一貫して支援し、各フェーズで顧客課題と市場性の適合を段階的に検証します。スプリント型の進行により、仮説検証とプロダクト改善のサイクルを高速化させることで、事業の確実な立ち上げと持続的な成長を実現します。",
    }
  ],
})

export const businessStartupSupportSchema = withFaqPageSchema(
  businessStartupSupportServiceSchema,
  businessStartupSupportPageMeta.url,
  businessStartupSupportFaqItems,
)
